<template>
    <div class="offset-md-1">
        <h6 class="mb-2 d-flex align-items-center">
            <b class="me-2">Current Smoking Status</b>
        </h6>
        <div class="row">
            <div class="form-group col-md-4 pe-1">
                <label for="smoking-status"> Smoking Status </label>
                <select class="form-select" v-model="patientHealthHistory.smokingStatus" id="smoking-status">
                    <option :value="0">Select Smoking Status</option>
                    <option :value="value.value" v-for="[key, value] of enumToMap(smokingStatusEnum)">
                        {{ value.name }}
                    </option>
                </select>
            </div>
            <div class="form-group col-md-4 px-1" v-if="!canHideSmokingDate">
                <label for="smokingStartDate">
                    Start Date
                    <span class="text-danger ms-1" v-if="patientHealthHistory.smokingStatus">*</span>
                </label>
                <DatePicker :options="startDatePickerOptions" :getDate="handleDateChange">
                    <div class="input-group date datepickerInput">
                        <input
                            type="text"
                            class="form-control"
                            name="smokingStartDate"
                            placeholder="MM/DD/YYYY"
                            :value="formatDateInput(patientHealthHistory.smokingStartDate)"
                            autocomplete="off"
                            @change="handleDateInputChange"
                        />
                        <div class="input-group-addon input-group-append">
                            <div class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </div>
                        </div>
                    </div>
                </DatePicker>
            </div>
            <div class="form-group col-md-4 px-1" v-if="!canHideSmokingDate">
                <label for="smokingEndDate"> Stop Date </label>
                <DatePicker :options="endDatePickerOptions" :getDate="handleDateChange">
                    <div class="input-group date datepickerInput">
                        <input
                            type="text"
                            class="form-control"
                            name="smokingEndDate"
                            placeholder="MM/DD/YYYY"
                            :value="formatDateInput(patientHealthHistory.smokingEndDate)"
                            autocomplete="off"
                            @change="handleDateInputChange"
                        />
                        <div class="input-group-addon input-group-append">
                            <div class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </div>
                        </div>
                    </div>
                </DatePicker>
            </div>
        </div>
    </div>
    <div class="offset-md-1">
        <h6 class="mb-2 d-flex align-items-center">
            <b class="me-2">Historical Smoking Status</b>
        </h6>
        <div class="row">
            <div class="form-group col-md-4 pe-1">
                <label for="historical-smoking-status"> Smoking Status </label>
                <select
                    class="form-select"
                    id="historical-smoking-status"
                    v-model="patientHealthHistory.historicalSmokingStatus"
                >
                    <option :value="0">Select Smoking Status</option>
                    <option :value="value.value" v-for="[key, value] of enumToMap(smokingStatusEnum)">
                        {{ value.name }}
                    </option>
                </select>
            </div>
            <div class="form-group col-md-4 px-1" v-if="!canHideHistoricalSmokingDate">
                <label for="historicalSmokingStartDate">
                    Start Date
                    <span class="text-danger ms-1" v-if="patientHealthHistory.historicalSmokingStatus">*</span>
                </label>
                <DatePicker :options="historicalStartDatePickerOptions" :getDate="handleDateChange">
                    <div class="input-group date datepickerInput">
                        <input
                            type="text"
                            class="form-control"
                            name="historicalSmokingStartDate"
                            placeholder="MM/DD/YYYY"
                            :value="formatDateInput(patientHealthHistory.historicalSmokingStartDate)"
                            autocomplete="off"
                            @change="handleDateInputChange"
                        />
                        <div class="input-group-addon input-group-append">
                            <div class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </div>
                        </div>
                    </div>
                </DatePicker>
            </div>
            <div class="form-group col-md-4 px-1" v-if="!canHideHistoricalSmokingDate">
                <label for="historicalSmokingEndDate">
                    Stop Date
                    <span class="text-danger ms-1">*</span>
                </label>
                <DatePicker :options="historicalEndDatePickerOptions" :getDate="handleDateChange">
                    <div class="input-group date datepickerInput">
                        <input
                            type="text"
                            class="form-control"
                            name="historicalSmokingEndDate"
                            placeholder="MM/DD/YYYY"
                            :value="formatDateInput(patientHealthHistory.historicalSmokingEndDate)"
                            @change="handleDateInputChange"
                        />
                        <div class="input-group-addon input-group-append">
                            <div class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </div>
                        </div>
                    </div>
                </DatePicker>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./HealthHistorySection.ts" />
